export default __webpack_public_path__ + "static/media/1918.824adbb8.png";